import { Link } from "react-router-dom";
import { Icon } from "../components/Icon";
import { SectionLink } from "../components/SectionLink";
import { REWARD_TERMS_PATH } from "../data/reward";
import { RichText, useSiteTranslation } from "../i18n";
import "../styles/reward.css";

/** The $100 Marriage Reward: couples who met and married on MJMarry share their story. */
export function MarriageRewardSection() {
  const { t } = useSiteTranslation();
  const steps = t("home.reward.steps", { returnObjects: true });
  const facts = t("home.reward.facts", { returnObjects: true });

  return (
    <section className="section reward" id="reward">
      <div className="wrap reward-grid">
        <div className="reward-copy" data-reveal>
          <p className="eyebrow reward-eyebrow">
            <Icon name="ring" />
            {t("home.reward.eyebrow")}
          </p>
          <h2>
            <RichText k="home.reward.title" />
          </h2>
          <p className="reward-lead">{t("home.reward.lead")}</p>
          <p className="reward-text">{t("home.reward.text")}</p>
          <p className="reward-tagline">{t("home.reward.tagline")}</p>
          <div className="reward-actions">
            <SectionLink className="reward-cta" hash="#download">
              {t("home.reward.cta")}
              <Icon name="arrow" />
            </SectionLink>
            <Link className="reward-terms" to={REWARD_TERMS_PATH}>
              {t("home.reward.terms")}
            </Link>
          </div>
        </div>

        <div className="reward-card" data-reveal style={{ "--delay": ".12s" }}>
          <div className="reward-card-head">
            <span className="reward-ring">
              <Icon name="ring" />
            </span>
            <div>
              <small>{t("home.reward.cardLabel")}</small>
              <strong dir="ltr">$100</strong>
              <span>{t("home.reward.perCouple")}</span>
            </div>
          </div>

          <h3>{t("home.reward.stepsTitle")}</h3>
          <ol className="reward-steps">
            {steps.map((step, index) => (
              <li key={index}>
                <b>{index + 1}</b>
                <span>{step}</span>
              </li>
            ))}
          </ol>

          <ul className="reward-facts">
            {facts.map((fact) => (
              <li key={fact}>
                <Icon name="check" />
                {fact}
              </li>
            ))}
          </ul>
          <p className="reward-eligibility">
            {t("home.reward.eligibility")} <Link to={REWARD_TERMS_PATH}>{t("home.reward.terms")}</Link>
          </p>
        </div>
      </div>
    </section>
  );
}
